// @flow
import {
  combineReducers,
} from 'redux';

import ui from './ui';
import resources from './resources';
import filters from './filters';
import profile from './profile';
export * from './keyValueReducer';

const rootReducer = combineReducers({
  ui,
  profile,
  filters,
  ...resources,
});

export default rootReducer;
